const STORAGE_PREFIX = 'page-view-preferences:';

function currentUserKey() {
  try {
    const user = JSON.parse(window.localStorage.getItem('user') || '{}');
    return String(user.id ?? user.Id ?? user.email ?? 'anonymous');
  } catch {
    return 'anonymous';
  }
}

function storageKey() {
  return `${STORAGE_PREFIX}${currentUserKey()}`;
}

function readAll() {
  try {
    const raw = window.localStorage.getItem(storageKey());
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function readPageViewPreference(pageKey) {
  const entry = readAll()[pageKey];
  return entry && typeof entry === 'object' ? entry : {};
}

export function writePageViewPreference(pageKey, patch) {
  try {
    const all = readAll();
    const prev = all[pageKey] && typeof all[pageKey] === 'object' ? all[pageKey] : {};
    all[pageKey] = { ...prev, ...patch };
    window.localStorage.setItem(storageKey(), JSON.stringify(all));
  } catch (err) {
    console.warn('Could not save page view preferences', err);
  }
}

export function clearPageViewPreference(pageKey) {
  try {
    const all = readAll();
    if (!all[pageKey]) return;
    delete all[pageKey];
    window.localStorage.setItem(storageKey(), JSON.stringify(all));
  } catch (err) {
    console.warn('Could not clear page view preferences', err);
  }
}
